<template>
  <date-range-picker class="date-picker" :initial-value="range" @change="change" />
</template>

<script>
import DateRangePicker from '../components/inputs/date-time/date-range-picker'

export default {
  components: { DateRangePicker },

  props: {
    initialRange: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  emits: ['change'],

  data() {
    return {
      range: this.initialRange
    }
  },

  methods: {
    change(newRange) {
      if (newRange) {
        const newRangeObj = {
          start_date: newRange[0],
          end_date: newRange[1]
        }
        this.range = newRangeObj
        this.$emit('change', newRangeObj)
      }
      else {
        // Null
        this.range = newRange
        this.$emit('change', newRange)
      }
    }
  }
}
</script>
